import React from 'react';

const PrestigeLogo = ({ className = "h-16" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/plogo_edit-removebg-preview.png" 
        alt="Prestige Events Logo" 
        className="h-full w-auto object-contain"
      />
    </div>
  );
};

export default PrestigeLogo;
